export const PAGINATION_META = {
  from: 0,
  to: 0,
  total: 0,
  current_page: 1,
  last_page: 1,
  per_page: 15,
}
